import { Record as record } from 'immutable';

import { resolve } from '../../helpers/LinkMapper';

const defaults = {
    id: null,
    voucherId: null,
    code: null,
    amount: 0,
    campaignName: null,
    campaignTerms: null,
};

class AppliedVoucher extends record(defaults) {

    static fromJSON (json = {}) {
        const voucherId = resolve(json.voucherId).with(Number);
        const id = `/vouchers/${voucherId}`;
        return new AppliedVoucher({
            id,
            voucherId,
            amount: resolve(json.amount).with(Number),
            code: resolve(json.code).with(String),
            campaignName: resolve(json.campaignName).with(String),
            campaignTerms: resolve(json.campaignTerms).with(String),
        });
    }
}

export default AppliedVoucher;
